export const MEMBER_TYPE_RESIDENT = 'RESIDENT';
export const MEMBER_TYPE_EMPLOYEE = 'EMPLOYEE';

export const MESSAGE_TYPE_VIEW_NOTICE = 'NOTICE';
export const MESSAGE_TYPE_VIEW_MESSAGE = 'TEXT';
export const MESSAGE_TYPE_VIEW_IMAGES = 'IMAGES';
